import { ReactNode } from 'react';
import { TextVariant } from './types';

export const getCongratsText = (ticketCnt: number, isMobile: boolean): ReactNode =>
  isMobile ? (
    <>
      오프라인 이벤트 참가권을 총 <span>{ticketCnt}장</span> 획득했어요.
    </>
  ) : (
    <>
      오프라인 이벤트 참가권을
      <br /> 총 <span>{ticketCnt}장</span> 획득했어요.
    </>
  );

export const PROGRESS_TICKET_CONSTANTS: Record<string, TextVariant> = {
  remainText: { common: '남은 오프라인 이벤트 참가권' },
  remainSubText: {
    common: (
      <>
        참가권은 <span>대회 당 4장 시트 (총 96장)</span> 지급됩니다.
      </>
    ),
  },
  congratsText: { common: '축하합니다!' },
  congratsSubText2: {
    common: (
      <>
        오프라인 이벤트 탭을
        <br /> 확인해주세요!
      </>
    ),
    mobile: <>오프라인 이벤트 탭을 확인해주세요!</>,
  },
  needTicketSubTitle: {
    common: '오프라인 이벤트 참가권',
    mobile: '오프라인 이벤트 참가권 획득 여부',
  },
  needTicketText: {
    common: (
      <>
        아직 참가권을
        <br /> 획득하지 못했습니다.
      </>
    ),
    mobile: <>참가권을 아직 획득하지 못했습니다.</>,
  },
  needTicketSubText: {
    common: (
      <>
        새틀라이트를 통해
        <br /> 참가권을 획득해주세요!
      </>
    ),
    mobile: <>새틀라이트를 통해 참가권을 획득해주세요!</>,
  },
  checkParticipateBtn: { common: '참가 방법', mobile: '새틀라이트\n참가 방법' },
  goTournamentBtn: { common: '새틀라이트 참가하기' },
  goMainEventBtn: { common: '오프라인 이벤트 확인하기' },
};
